import { render, staticRenderFns } from "./GdCard.vue?vue&type=template&id=21def82a"
import script from "./GdCard.vue?vue&type=script&lang=js"
export * from "./GdCard.vue?vue&type=script&lang=js"
import style0 from "./GdCard.vue?vue&type=style&index=0&id=21def82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports